import * as types from './types'

export const showPageLoading = ({commit}) => {
  commit(types.PAGE_LOADING_QUERY, {
    show: true
  })
}

export const hidePageLoading = ({commit}) => {
  commit(types.PAGE_LOADING_QUERY, {
    show: false
  })
}

export const routerLoading = ({commit}, val) => {
  commit(types.PAGE_ROUTER_LOADING, val)
}


// WEBPACK FOOTER //
// ./src/store/actions.js